module.exports = __webpack_public_path__ + "static/music_mobile_app_cover-3ca99144aa7923c9b7019a852a306f53.png";